export const cookieDetailList = [
  {
    title: 'Necesario',
    key: 'cookie_necesarias',
    description:
      'Las cookies necesarias ayudan a hacer una página web utilizable activando funciones básicas como la navegación en la página y el acceso a áreas seguras de la página web. La página web no puede funcionar adecuadamente sin estas cookies.',
    items: ['next-i18next', 'joinnus2', '_ga', 'consentCookies'],
    isChecked: true,
    isMandatory: true,
    disabled: true
  },
  {
    title: 'Estadisticas',
    key: 'cookie_administration',
    description:
      'Las cookies estadísticas ayudan a los propietarios de páginas web a comprender cómo interactúan los visitantes con las páginas web reuniendo y proporcionando información de forma anónima.',
    items: ['_ga'],
    isChecked: false,
    isMandatory: false,
    disabled: false
  },
  {
    title: 'No clasificados',
    key: 'cookie_otros',
    description:
      'Las cookies no clasificadas son cookies para las que todavía estamos en proceso de clasificar, junto con los proveedores de cookies individuales.',
    items: ['next-i18next'],
    isChecked: false,
    isMandatory: false,
    disabled: false
  },
];
export const getCookie = (name) => {
  const re = new RegExp(`${name}=([^;]+)`);
  const value = re.exec(document.cookie);
  return value != null ? unescape(value[1]) : null;
};

export const removeCookie = (substring) => {
  const cookies = document.cookie.split(';');
  cookies.forEach((cookie) => {
    const [name] = cookie.trim().split('=');
    if (name.includes(substring)) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });
};

export const setCookie = (name, value, days = 30) => {
  const expires = new Date();
  const domain = window.location.hostname === 'localhost' ? 'localhost' : 'joinnus.com';
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};domain=${domain};path=/`;
};

export const getCookieName = (name) => {
  if (typeof document !== 'undefined') {
    const cookies = document.cookie.split(';');
    // eslint-disable-next-line
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === name) return cookieValue;
    }
  }
  return null;
};
